/*
 * @Author: mina.min
 * @Date: 2025-06-09 16:38:31
 * @LastEditors: mina.min
 * @LastEditTime: 2025-06-21 16:30:50
 * @FilePath: /OTAManagementSystem/src/main.tsx
 * @Description:
 */
import { ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
  <BrowserRouter>
    <ConfigProvider locale={zhCN}>
      <App />
    </ConfigProvider>
  </BrowserRouter>
  // </React.StrictMode>
)
